import React from 'react'
import { Modal } from '@components/ui'

type MarketingDeleteCampaignTemplateModalProps = {
  show: boolean
  templateName: string
  onCancel: () => void
  onDelete: () => void
}

const MarketingDeleteCampaignTemplateModal: React.FC<
  MarketingDeleteCampaignTemplateModalProps
> = ({ show, templateName, onCancel, onDelete }) => {
  const titleName = templateName.trim() || 'this'

  return (
    <Modal
      open={show}
      onClose={onCancel}
      size="xs"
      title="Delete Template"
      description={`Are you sure you want to delete the ${titleName} campaign template? This action cannot be undone.`}
      primaryLabel="Delete"
      secondaryLabel="Cancel"
      primaryDestructive
      onPrimaryClick={onDelete}
      onSecondaryClick={onCancel}
    />
  )
}

export default MarketingDeleteCampaignTemplateModal
